import { TCategory } from '../models'

export const getInitialCategoriesExpanded = (categories: TCategory[]) => {
  const guids = categories
    .filter((category) => category.subcategories.length)
    .map((category) => category.guid)
  const result: Record<string, boolean> = {}
  guids.forEach((i) => {
    result[i] = false
  })

  return result
}

/**
 * Mutates categoriesExpanded
 * @param categoriesExpanded
 * @param subcategoryToCategory
 * @param chosenGUIDs
 */
export const expandChosenCategories = (
  categoriesExpanded: Record<string, boolean>,
  subcategoryToCategory: Record<string, string>,
  chosenGUIDs: string[]
) => {
  for (const guid of chosenGUIDs) {
    const categoryGUID = subcategoryToCategory[guid]
    if (categoryGUID && categoriesExpanded[categoryGUID] !== undefined) {
      categoriesExpanded[categoryGUID] = true
    }
  }
}

export const mapSubcategoryToCategory = (categories: TCategory[]) => {
  const map: Record<string, string> = {}
  categories.forEach((category) => {
    category.subcategories.forEach((subcategory) => {
      map[subcategory.guid] = category.guid
    })
  })

  return map
}
